import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=080b4302"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=080b4302&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports